import { render, staticRenderFns } from "./MyMailings.vue?vue&type=template&id=b8423c56"
import script from "./MyMailings.vue?vue&type=script&lang=js"
export * from "./MyMailings.vue?vue&type=script&lang=js"
import style0 from "./MyMailings.vue?vue&type=style&index=0&id=b8423c56&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports